import { useMutation, gql } from '@apollo/client';
import {
  EditarDisciplinaMutation,
  EditarDisciplinaMutationVariables,
} from './__generated__/EditarDisciplinaMutation';

const EDITAR_DISCIPLINA_MUTATION = gql`
  mutation EditarDisciplinaMutation(
    $id_disciplina: Int!
    $dsc_nome_disciplina: String
    $dsc_sigla: String
    $dsc_ementa: String
    $num_carga_horaria: Int
  ) {
    editarDisciplina(
      input: {
        id_disciplina: $id_disciplina
        dsc_nome_disciplina: $dsc_nome_disciplina
        dsc_sigla: $dsc_sigla
        dsc_ementa: $dsc_ementa
        num_carga_horaria: $num_carga_horaria
      }
    ) {
      id_disciplina
      dsc_nome_disciplina
      dsc_sigla
      dsc_ementa
      num_carga_horaria
    }
  }
`;

const useEditarDisciplinaMutation = () => {
  return useMutation<EditarDisciplinaMutation, EditarDisciplinaMutationVariables>(
    EDITAR_DISCIPLINA_MUTATION
  );
};

export { useEditarDisciplinaMutation };
